import { render, staticRenderFns } from "./AfterYouApply.vue?vue&type=template&id=0125ccf8&"
import script from "./AfterYouApply.vue?vue&type=script&lang=js&"
export * from "./AfterYouApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports